export const QUERY_KEY = "QUERY_KEY";

export const GET_USER = "GET_USER";

export const GET_MENU = "GET_MENU";
export const GET_MENU_LIST = "GET_MENU_LIST";

export const GET_SCREEN = "GET_SCREEN";
export const GET_SCREEN_NUMBER = "GET_SCREEN_NUMBER";
export const GET_SCREEN_ROUTE = "GET_SCREEN_ROUTE";

/** 공통코드 조회 */
export const GET_STM_CODE = "GET_STM_CODE";

export const GET_SUB_STM_CODE = "GET_SUB_STM_CODE";

/* 거래처 관리 */
export const GET_CUSTOMER_MANAGE = "GET_CUSTOMER_MANAGE";

// 프로젝트 카테고리
export const GET_PROJECT_CATEGORYS = "GET_PROJECT_CATEGORYS";
// 프로젝트 단계
export const GET_PROJECT_PHASE = "GET_PROJECT_PHASE";
// 프로젝트 PM
export const GET_PROJECT_PM = "GET_PROJECT_PM";
// 화면유형
export const GET_SCREEN_TYPE = "GET_SCREEN_TYPE";
// 업무구분
export const GET_MENU_TYPE = "GET_MENU_TYPE";

/** 복사 붙여넣기 */
/** 권한 그룹별 목록 조회 */
export const GET_GROUP_PERMISSIONS = "GET_GROUP_PERMISSIONS";

/** 권한 목록 조회 */
export const GET_PERMISSIONS = "GET_PERMISSIONS";

/** 사용자 목록 조회 */
export const GET_MEMBERS = "GET_MEMBERS";

/** 권한 select options 조회 */
export const GET_PERMISSION_SELECT_OPTIONS = "GET_PERMISSION_SELECT_OPTIONS";

/** 프로젝트 등록 조회 */
export const GET_PROJECTS = "GET_PROJECTS";

/** 대일정 등록 조회 */
export const GET_MAJOR_SCHEDULE = "GET_MAJOR_SCHEDULE";

/** 단위일정 등록 조회 */
export const GET_SUB_SCHEDULE = "GET_SUB_SCHEDULE";

/* 실적 등록 조회 */
export const GET_PERFORMANCE_RECORDS = "GET_PERFORMANCE_RECORDS";

/* 주간업무보고 기록 */
export const GET_WEEKLY_RECORDS = "GET_WEEKLY_RECORDS";

/* 캘린더 */
export const GET_CALENDAR = "GET_CALENDAR";

/* 공휴일 조회 */
export const GET_HOLIDAY = "GET_HOLIDAY";
export const GET_HOLIDAY_API_URL =
  "https://apis.data.go.kr/B090041/openapi/service/SpcdeInfoService/getRestDeInfo";

/* 회의록 */
export const GET_PROCEEDINGS = "GET_PROCEEDINGS";

/* 문서 관리 */
export const GET_DOCUMENT_MANAGEMENT = "GET_DOCUMENT_MANAGEMENT";

/* 연차 등록 */
export const GET_ANNUAL_REGIST = "GET_ANNUAL_REGIST";

/* 파일추가 */
export const GET_FILES = "GET_FILES";

/* 익명게시판 */
export const GET_ABOARDS = "GET_ABOARDS";

/* 익명게시판 카테고리 */
export const GET_ABOARD_CATEGORY = "GET_ABOARD_CATEGORY";

/* 피드백 게시판 */
export const GET_FEEDBACK = "GET_FEEDBACK";

/* 피드백 게시판 상태 */
export const GET_FEEDBACK_STATE = "GET_FEEDBACK_STATE";

/* 피드백 게시판 카테고리 */
export const GET_FEEDBACK_CATEGORY = "GET_FEEDBACK_CATEGORY";

/* 위시캣 프로젝트 지원 */
export const GET_WISHKET_SUPPORT = "GET_WISHKET_SUPPORT";

/* 위시캣 프로젝트 지원 상태 */
export const GET_WISHKET_SUPPORT_STATE = "GET_WISHKET_SUPPORT_STATE";

/* 접속 정보 */
export const GET_ACCESS_INFORMATION = "GET_ACCESS_INFORMATION";

/* 환경 변수 */
export const GET_ENVIRONMENTAL_VAR = "GET_ENVIRONMENTAL_VAR";

/* 공지 사항 게시판 */
export const GET_NOTICE_BOARDS = "GET_NOTICE_BOARDS";

/* 공지 사항 카테고리 */
export const GET_NOTICE_CATEGORY = "GET_NOTICE_CATEGORY";
